<template>
  <section :class="$style.bus">
    <sub-title :class="$style.title" title="バス時刻表"></sub-title>
    ※時刻は変更になっている場合もありますので、詳細は各交通機関のHP等でご確認ください。<br />
    (<a href="https://www.city.nomi.ishikawa.jp/www/genre/1000100000278/">のみバスHPへはこちらから</a>)<br />
    <div :id="$style.bus_grid">
      <div :id="$style.bus_detail">
        <div :class="$style.grid">
          <div :id="$style.nomibus">
            <div :id="$style.radius">
              <div :class="$style.middle_title">
                (1)観光能美バス<br />「IRいしかわ鉄道線 能美根上駅」<br />より
                松井秀喜ベースボールミュージアム行
              </div>
              <table>
                <tr>
                  <th>能美根上駅発</th>
                  <th>ミュージアム・発着</th>
                  <th>能美根上駅着</th>
                </tr>
                <tr>
                  <td>9:00</td>
                  <td>9:11</td>
                  <td>9:25</td>
                </tr>
                <tr>
                  <td>10:00</td>
                  <td>10:11</td>
                  <td>10:25</td>
                </tr>
                <tr>
                  <td>12:00</td>
                  <td>12:11</td>
                  <td>12:25</td>
                </tr>
                <tr>
                  <td>14:00</td>
                  <td>14:11</td>
                  <td>14:25</td>
                </tr>
                <tr>
                  <td>16:00</td>
                  <td>16:11</td>
                  <td>16:25</td>
                </tr>
              </table>
              <table>
                <tr>
                    <th>土日祝日のみ運行</th>
               </tr>
              </table>
              <li>片道料金：100円</li>
              <!-- <li>観光能美バスは、能美根上駅を中心に次の観光施設を巡回しています。</li>
              <li>
                松井秀喜ベースボールミュージアム・新博物館・九谷陶芸館・いしかわ動物園・辰口温泉口
              </li> -->
              <li>陶芸村・辰口温泉行のルートとは異なりますので、ご注意ください</li>
              <li>詳細は<a href="https://www.city.nomi.ishikawa.jp/www/contents/1001100000001/index.html">こちら</a>からご確認ください</li>
            </div>
          </div>
          <div :id="$style.komatsubus">
            <div :id="$style.radius">
              <div :class="$style.middle_title">
                (2)小松バス「IRいしかわ鉄道線 小松駅」<br />より 小松バス長崎行
              </div>
              <table>
                <tr>
                  <th>小松駅発</th>
                  <th>長崎停留所・発着</th>
                  <th>小松駅着</th>
                </tr>
                <tr>
                  <td>9:01</td>
                  <td>9:19</td>
                  <td>9:38</td>
                </tr>
                <tr>
                  <td>13:11</td>
                  <td>13:29</td>
                  <td>13:48</td>
                </tr>
                <tr>
                  <td>17:11</td>
                  <td>17:29</td>
                  <td>17:48</td>
                </tr>
              </table>
              <table>
                <tr>
                  <th>毎日運行</th>
                </tr>
              </table>
              <li>片道料金：340円</li>
              <li>長崎停留所からミュージアムまで徒歩約5分</li>
            </div>
          </div>
          <div :class="border - wide"></div>
          <div :id="$style.communitybus">
            <div :id="$style.radius">
              <div :class="$style.middle_title">
                (3)能美市コミュニティバス<br />「IRいしかわ鉄道線 能美根上駅」<br />より山口停留所行（平日）
              </div>
              <table>
                <tr>
                  <th>能美根上駅発</th>
                  <th>山口停留所・発着</th>
                  <th>能美根上駅着</th>
                </tr>
                <tr>
                  <td>8:49</td>
                  <td>9:00</td>
                  <td>9:21</td>
                </tr>
                <tr>
                  <td>9:49</td>
                  <td>10:00</td>
                  <td>10:21</td>
                </tr>
                <tr>
                  <td>10:49</td>
                  <td>11:00</td>
                  <td>11:21</td>
                </tr>
                <tr>
                  <td>11:49</td>
                  <td>12:00</td>
                  <td>12:21</td>
                </tr>
                <tr>
                  <td>13:49</td>
                  <td>14:00</td>
                  <td>14:21</td>
                </tr>
                <tr>
                  <td>14:49</td>
                  <td>15:00</td>
                  <td>15:21</td>
                </tr>
                <tr>
                  <td>16:49</td>
                  <td>17:00</td>
                  <td>17:21</td>
                </tr>
              </table>
              <table>
                <tr>
                  <th>平日時刻表</th>
                </tr>
              </table>
              <li>乗車運賃：100円(均一)</li>
              <li>山口停留所からミュージアムまで徒歩約7分</li>
              <li>詳細は<a href="https://www.city.nomi.ishikawa.jp/www/contents/1001100000013/index.html">こちら</a>からご確認ください</li>
              <li>土日祝日の時刻表は(4)をご確認ください</li>
            </div>
          </div>
          <div :class="border - wide"></div>
          <div :id="$style.communitybus2">
            <div :id="$style.radius">
              <div :class="$style.middle_title">
                (4)能美市コミュニティバス<br />「IRいしかわ鉄道線 能美根上駅」<br />より山口停留所行（土日祝）
              </div>
              <table>
                <tr>
                  <th>能美根上駅発</th>
                  <th>山口停留所・発着</th>
                  <th>能美根上駅着</th>
                </tr>
                <tr>
                  <td>8:49</td>
                  <td>9:00</td>
                  <td>9:21</td>
                </tr>
                <tr>
                  <td>11:49</td>
                  <td>12:00</td>
                  <td>12:21</td>
                </tr>
                <tr>
                  <td>14:49</td>
                  <td>15:00</td>
                  <td>15:21</td>
                </tr>
              </table>
              <table>
                <tr>
                  <th>土日祝時刻表</th>
                </tr>
              </table>
              <li>乗車運賃：100円(均一)</li>
              <li>山口停留所からミュージアムまで徒歩約7分</li>
              <li>詳細は<a href="https://www.city.nomi.ishikawa.jp/www/contents/1001100000014/index.html">こちら</a>からご確認ください</li>
              <li>平日時刻表は(3)をご確認ください</li>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SubTitle from "@/components/atoms/SubTitle.vue";

export default Vue.extend({
  name: "BusScheduleVisual",
  components: {
    SubTitle,
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .bus {
    .caution{
      color: #2e8b57;
      font-weight: bold;
    }
    .grid {
      display: grid;
      row-gap: 10px;
      justify-content: center;
      #nomibus {
        grid-row: 1;
        justify-self: center;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 1;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
      #komatsubus {
        grid-row: 2;
        justify-self: center;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 2;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
      #communitybus {
        grid-row: 3;
        justify-self: center;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 3;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
      #communitybus2 {
        grid-row: 4;
        justify-self: center;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 4;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
    }
    
    #bus_grid {
      .middle_title {
        font-size: 19px;
        color: #38761d;
        margin: 8px 0;
        text-align: center;
      }
    }
  }
  $c-main: #46b1c9;

  .c-bg--stripe {
    padding: 0.25em;
    background-image: repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 4px,
      rgba($c-main, 0.25) 4px,
      rgba($c-main, 0.25) 8px
    );
  }
}
@media only screen and (min-width: 1024px) {
  .bus {
    .caution{
      color: #ff3333;
      font-weight: bold;
    }
    .grid {
      display: grid;
      grid-template-columns: 1fr 1.5fr 1.5fr 1fr;
      grid-template-rows: 1fr 50px 1.3fr;
      justify-content: center;
      li {
        font-size: 14px;
      }
      #nomibus {
        grid-row: 1;
        grid-column: 1/3;
        margin-right: 15px;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 1;
          grid-column: 1/3;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }

      #komatsubus {
        grid-row: 1;
        grid-column: 3/5;
        margin-left: 15px;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 1;
          grid-column: 3/5;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }

      #communitybus {
        grid-row: 3;
        grid-column: 1/3;
        margin-left: 15px;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 3;
          grid-column: 1/3;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
      #communitybus2 {
        grid-row: 3;
        grid-column: 3/5;
        margin-left: 15px;
        table {
          border-collapse: collapse;
          margin: 0 auto;
          color: #2e8b57;
          text-align: center;
          vertical-align: middle;
          width: 100%;
          margin-bottom: 10px;
          tr:last-child td {
            border-bottom: 2px solid #2e8b57;
          }
          th {
            font-size: 13px;
            padding: 6px;
          }
          td {
            padding: 8px;
          }
          tr:first-child {
            background-image: linear-gradient(
              -45deg,
              #e6ffe6 15%,
              #fff 15%,
              #fff 25%,
              #e6ffe6 25%,
              #e6ffe6 65%,
              #fff 65%,
              #fff 75%,
              #e6ffe6 75%,
              #e6ffe6
            );
            background-size: 15px 15px;
          }
        }
        #radius {
          border: 2px solid #cccccc;
          grid-row: 3;
          grid-column: 3/5;
          border-radius: 10px;
          padding: 5%;
          display: inline-block;
        }
      }
    }
    #bus_grid {
      .middle_title {
        font-size: 16px;
        color: rgba(63, 107, 120, 1);
        margin-bottom: 10px;
        text-align: center;
      }
    }
  }
  h1 {
    color: #010079;
    text-shadow: 0 0 5px white;
    border-left: solid 7px #010079;
    background: -webkit-repeating-linear-gradient(
      -45deg,
      #cce7ff,
      #cce7ff 3px,
      #e9f4ff 3px,
      #e9f4ff 7px
    );
    background: repeating-linear-gradient(
      -45deg,
      #cce7ff,
      #cce7ff 3px,
      #e9f4ff 3px,
      #e9f4ff 7px
    );
  }
}
</style>
